// extracted by mini-css-extract-plugin
module.exports = {"toggle":"mobile-menu-toggle_toggle__3ScKu"};